import React from 'react'
import Modal from 'react-modal'
import FloatingLabel from '../components/floating-label'
import Choices from 'choices.js'
import { useMutation } from '@apollo/client'
import createStudent from '../mutations/create-student'

const className = {
  base: 'full-modal',
  afterOpen: 'modal-after-open',
  beforeClose: 'modal-before-close',
}

const overlayClassName = {
  base: 'overlay',
  afterOpen: 'overlay-after-open',
  beforeClose: 'overlay-before-close',
}

function CreateUserModal(props) {
  const [firstName, setFirstName] = React.useState('')
  const [lastName, setLastName] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [graduationYear, setGraduationYear] = React.useState(
    new Date().getFullYear()
  )
  const [choices, setChoices] = React.useState([])
  const [createStudentMutation] = useMutation(createStudent)

  const initializeGraduationYear = (element) => {
    const choices = new Choices(element, {
      shouldSort: false,
      shouldSortItems: false,
    })

    setChoices(choices)
  }

  const handleClose = (e) => {
    e.preventDefault()

    const { onClose } = props
    onClose(null)
  }

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value)
  }

  const handleLastNameChange = (e) => {
    setLastName(e.target.vale)
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value)
  }

  const handleGraduationYearChange = (e) => {
    setGraduationYear(e.target.value)
  }

  const handleSave = (e) => {
    e.preventDefault()

    const { onClose } = props
    const variables = { firstName, lastName, email, graduationYear }

    createStudentMutation({
      variables: variables,
    }).then(() => {
      onClose(null)
      setFirstName('')
      setLastName('')
      setEmail('')
      setGraduationYear(new Date().getFullYear())
    })
  }

  const { isOpen } = props

  const currentYear = new Date().getFullYear()
  const years = Array.from({ length: 10 }, (x, i) =>
    (currentYear + i).toString()
  )

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel={'Pulse Modal'}
      className={className}
      overlayClassName={overlayClassName}
    >
      <header className="full-modal-header">
        <a href="/" className="logo">
          <img src="/images/logo.png" className="logo" alt="" />
        </a>
        <h2>Create User</h2>
        <nav role="navigation" aria-label="App Navigation">
          <a href="#" onClick={handleClose}>
            Close
            <i className="material-icons">close</i>
          </a>
        </nav>
      </header>
      <div className="full-modal-body">
        <section id="admin-users">
          <div className="container">
            <div className="header">
              <h1>Create Student</h1>
              <nav className="actions">
                <a className="button" onClick={handleClose}>
                  Back
                </a>
              </nav>
            </div>
          </div>
          <div className="container flex">
            <div className="well">
              <form onSubmit={handleSave}>
                <FloatingLabel
                  labelText="First Name"
                  labelFor="user_first_name"
                >
                  <input
                    id="user_first_name"
                    name="user[first_name]"
                    onChange={handleFirstNameChange}
                    required
                    type="text"
                    value={firstName}
                  />
                </FloatingLabel>
                <FloatingLabel labelText="Last Name" labelFor="user_last_name">
                  <input
                    id="user_last_name"
                    name="user[last_name]"
                    onChange={handleLastNameChange}
                    required
                    type="text"
                    value={lastName}
                  />
                </FloatingLabel>
                <FloatingLabel labelText="Email" labelFor="user_email">
                  <input
                    id="user_email"
                    name="user[email]"
                    onChange={handleEmailChange}
                    required
                    type="text"
                    value={email}
                  />
                </FloatingLabel>
                <div id="user_graduation_choices">
                  <select
                    ref={initializeGraduationYear}
                    onChange={handleGraduationYearChange}
                    value={graduationYear}
                  >
                    {years.map((year) => (
                      <option value={year}>{year}</option>
                    ))}
                  </select>
                </div>
                <input type="submit" value="Create Student" />
              </form>
            </div>
          </div>
        </section>
      </div>
    </Modal>
  )
}

export default CreateUserModal
